import Grid from '@mui/material/Grid';

import OpenMoreReportsOrModulesPopperButton from '../OpenMoreReportsOrModulesButton/OpenMoreReportsOrModulesButton';
import SidebarSeparatorShadow from '../SidebarSeparatorShadow/SidebarSeparatorShadow';

const MoreButtonsOnly = () => {
  return (
    <Grid container flexDirection="column" flex={1}>
      <Grid display="flex" item alignItems="center" flex={1}>
        <OpenMoreReportsOrModulesPopperButton canDisplayAllItems={false} isMoreReportsButton />
      </Grid>
      <SidebarSeparatorShadow />
      <Grid display="flex" item alignItems="center" flex={1}>
        <OpenMoreReportsOrModulesPopperButton canDisplayAllItems={false} isMoreReportsButton={false} />
      </Grid>
    </Grid>
  );
};

export default MoreButtonsOnly;
